// TODO find a lighter library for getting device info
import { UAParser } from 'ua-parser-js';

interface DeviceInfo {
  os: string;
  osVersion: string;
  model: string;
}

let cachedDeviceInfo: DeviceInfo | null = null;

export function getDeviceInfo(): DeviceInfo {
  const ua = navigator.userAgent;

  if (cachedDeviceInfo) return cachedDeviceInfo;

  const { os, device } = UAParser(ua);

  cachedDeviceInfo = {
    os: os?.name || 'Unknown',
    osVersion: os?.version || 'Unknown',
    model: ua.includes('Windows')
      ? 'PA_Windows'
      : device?.toString() || 'Unknown',
  };

  return cachedDeviceInfo;
}
